require('./angular-messages');
module.exports = 'ngMessages';



//////////////////
// WEBPACK FOOTER
// ../~/angular-messages/index.js
// module id = 79
// module chunks = 1